module.exports = __webpack_public_path__ + "img/neokylin.de80019d.png";